<app-header></app-header>

<div id="html2canvas-container"> 
  <div class="row mt-4 ml-1 mr-1">
    <ngx-spinner></ngx-spinner>
    <div class="col-lg-2 col-md-2">
      <img src="{{baseUrl + specpage[i].productName}}" alt="{{specpage[i].productName}}"
        title="{{specpage[i].productName}}" class="rounded img-fluid">
    </div>
    <div class="col-lg-10  col-md-10">
      <h3>{{specpage[i].nomenclature}}</h3>
      <h4>{{specpage[i].title}}</h4>
      <p class="text-left" style="white-space: pre-wrap" innerHTML="{{specpage[i].featuresBenefits}}"></p>
    </div>
  </div>

  <hr />

  <div class="row ml-1 mr-1">

    <div class="col-lg-6">
      <div class="card bg-light mb-3">
        <div class="card-header">
          <h5>Product Details</h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-lg-6">
              <div class="table-responsive">
                <table class="table table-sm table-hover table-striped table-bordered">
                  <tbody>
                    <tr>
                      <td class="col-5">Nomenclature :</td>
                      <td>{{specpage[i].nomenclature}}</td>
                    </tr>
                    <tr>
                      <td>Material :</td>
                      <td>{{specpage[i].material}}</td>
                    </tr>
                    <tr>
                      <td>Print Group :</td>
                      <td>{{specpage[i].designName}}</td>
                    </tr>
                    <tr>
                      <td>Title :</td>
                      <td>{{specpage[i].title}}</td>
                    </tr>
                    <tr>
                      <td>Size :</td>
                      <td>{{specpage[i].size}}</td>
                    </tr>
                    <tr>
                      <td>Lid Color :</td>
                      <td>{{specpage[i].lidColor}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="table-responsive">
                <table class="table table-sm table-hover table-striped table-bordered">
                  <tbody>
                    <tr>
                      <td class="col-5">Cup Height :</td>
                      <td>{{specpage[i].cupHeight}}</td>
                    </tr>
                    <tr>
                      <td>Item Dimensions :</td>
                      <td>{{specpage[i].itemDimensions}}</td>
                    </tr>
                    <tr>
                      <td>Flush Fill :</td>
                      <td>{{specpage[i].flushFill}}</td>
                    </tr>
                    <tr>
                      <td>Practical Fill :</td>
                      <td>{{specpage[i].practicalFill}}</td>
                    </tr>
                    <tr>
                      <td>Width At Bottom :</td>
                      <td>{{specpage[i].widthatBottom}}</td>
                    </tr>
                    <tr>
                      <td>Width At Rim :</td>
                      <td>{{specpage[i].widthatRim}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-6">
      <div class="card bg-light mb-3">
        <div class="card-header">
          <h5>Shipping Details</h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-lg-6">
              <div class="table-responsive">
                <table class="table table-sm table-hover table-striped table-bordered">
                  <tbody>
                    <tr *ngIf="isPrinting; else elseBlock">
                      <td class="col-5">Case Pack:</td>
                      <td *ngIf="specpage?.length > 1; else noSelect">
                        <select [model]="i" (change)="SwitchIndex($event)">
                          <option *ngFor="let sp of specpage; index as j" value={{j}}>{{specpage[j].casePack}} </option>
                        </select>
                      </td>
                      <ng-template #noSelect>
                        <td>{{specpage[i].casePack}}</td>
                      </ng-template>
                    </tr>
                    <ng-template #elseBlock>
                      <tr>
                        <td class="col-5">Case Pack:</td>
                        <td>{{specpage[i].casePack}}</td>
                      </tr>
                    </ng-template>
                    <tr>
                      <td class="col-5">Part:</td>
                      <td>{{specpage[i].part}}</td>
                    </tr>
                    <tr>
                      <td>SCC:</td>
                      <td>{{specpage[i].scc}}</td>
                    </tr>
                    <tr>
                      <td>UPC:</td>
                      <td>{{specpage[i].upc}}</td>
                    </tr>
                    <tr>
                      <td>Weight:</td>
                      <td>{{specpage[i].weight}}</td>
                    </tr>
                    <tr>
                      <td>Cube:</td>
                      <td>{{specpage[i].cube}}</td>
                    </tr>
                    <tr>
                      <td>Length:</td>
                      <td>{{specpage[i].length}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="table-responsive">
                <table class="table table-sm table-hover table-striped table-bordered">
                  <tbody>
                    <tr>
                      <td class="col-5">Height:</td>
                      <td>{{specpage[i].height}}</td>
                    </tr>
                    <tr>
                      <td>Width:</td>
                      <td>{{specpage[i].width}}</td>
                    </tr>
                    <tr>
                      <td>Pallets:</td>
                      <td>{{specpage[i].pallets}}</td>
                    </tr>
                    <tr>
                      <td>Ti:</td>
                      <td>{{specpage[i].ti}}</td>
                    </tr>
                    <tr>
                      <td>Hi:</td>
                      <td>{{specpage[i].hi}}</td>
                    </tr>
                    <tr>
                      <td>Sleeve Quantity:</td>
                      <td>{{specpage[i].sleeveQuantity}}</td>
                    </tr>
                    <tr>
                      <td>Sleeves:</td>
                      <td>{{specpage[i].sleeves}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

  <hr />

</div>

<div class="row ml-1 mr-1">
  <div class="col">
    <button class="btn btn-secondary" (click)="downloadSpec(productId, nomenclature)"><i class="far fa-file-pdf"></i>
      Download PDF</button>
    <button type="button" (click)="exportAsXLSX()" class="btn btn-secondary"><i class="far fa-file-excel"></i>
      Export Excel</button>
  </div>
</div>

<div class="row mt-5 ml-1 mr-1">
  <div class="col">
    <h4 class="pb-3">Compatible Items</h4>
    <div class="cards">
      <div *ngFor="let i of compatibleitems" class="card">
        <img src="{{baseUrl + i.productName}}" class="img-fluid" alt="{{i.productName}}" title="{{i.productName}}">
        <div class="card-body">
          <h5 class="card-title">{{i.nomenclature}}</h5>
          <p class="card-text">{{i.title}}</p>
          <a href="specpage/{{i.id}}" class="stretched-link" title="{{i.title}}"></a>
        </div>
      </div>
    </div>
  </div>
</div>